module.exports = __webpack_public_path__ + "img/about-us-cover.2393330e.png";